import { takeEvery, select, all, takeLatest, put } from 'redux-saga/effects';
import {
  AuthorizationApi,

  loginAction,

  createLoginSaga, refreshAccessToken,
  RoleNames,
} from '@smorder/logic';

import {
  navigate,
} from '../reducers/navigator.reducers';

import {
  loadOrders as loadOrdersAction,
  loadOrder as loadOrderAction,
  proceedOrder as proceedOrderAction,
  declineOrder as declineOrderAction,
  startPrintOrder as startPrintOrderAction,
  initPrinter as initPrinterAction,
  initPrinterFailed as initPrinterFailedAction,
  printOrderFailed as printOrderFailedAction,
  reconnectPrinter as reconnectPrinterAction,
  reconnectPrinterFinished as reconnectPrinterFinishedAction,
  printArticleList as printArticleListAction,
  actionOnOrdercard as actionOnOrdercardAction,
  setMode as setModeAction,
  resetOrderSearchValue as resetOrderSearchValueAction,
  setDeliveryTimeAction,
} from '../reducers/order.reducers';

import {
  loadOrders as loadSignageOrdersAction,
  loadLocation as loadLocationAction,
} from '../reducers/signage.reducers';

import {
  loadMenuTreeAction,
  updateMenuAction,
  updateCategoryAction,
  updateMenuEntryAction,
  loadProductsAction,
  updateProductAction,
  updateMenusAction,
  updateCategoriesAction,
  updateMenuEntriesAction,
  updateProductsAction,
  loadProductionPlacesAction,
} from '../reducers/menu.reducers';

import {
  loadMenuTree,
  updateMenu,
  updateCategory,
  updateMenuEntry,
  loadProducts,
  updateProduct,
  updateMenus,
  updateCategories,
  updateMenuEntries,
  updateProducts,
  loadProductionPlaces,
} from './menu.sagas';

import {
  loadOrders,
  loadOrder,
  proceedOrder,
  declineOrder,
  handleScan,
  handleOrderCardAction,
  setMode,
  scheduleSearchFieldReset,
  setDeliveryTime,
}
  from './order.sagas';
import { printOrder, initPrinter, initPrinterFailed, printFailed, reconnect, reconnectFinished, printArticleList } from './print.sagas';
import { loadSignageOrders, loadLocation } from './signage.sagas';

import { closeAlert as closeAlertAction } from '../reducers/alert.reducers';
import { closeAlert } from '../sagas/alert.sagas';

import {
  loadUiOptions as loadUiOptionsAction,
  setPendingScannerInput as setPendingScannerInputAction,
  toggleFullScreen as toggleFullScreenAction,
} from '../reducers/app.reducers';

import { loadUiOptions, toggleFullScreen } from '../sagas/app.sagas';

import config from '../../run-config';

import OrderApi from '../api/order';
import SignageApi from '../api/signage';
import AppApi from '../api/app';
import MenuApi from '../api/menu';

const allowedRoles = [RoleNames.Waiter];

export default function* rootSaga() {
  let authApi = null;
  let orderApi = null;
  let signageApi = null;
  let appApi = null;
  let menuGQLApi = null;
  let menuApi = null;

  function* tokenProvider() {
    const { accessToken, refreshToken, expiresAt } = yield select(state => state.authentication);
    return {
      accessToken,
      refreshToken,
      expiresAt,
    };
  }

  function* tokenRefreshTask() {
    return yield refreshAccessToken(authApi);
  }

  function optionProvider() {
    return {
      tokenRefreshTask,
      tokenProvider,
    };
  }

  authApi = new AuthorizationApi(config.apiHost, optionProvider, null, null, config.clientName);
  orderApi = new OrderApi(config.apiHost, optionProvider, null, null, config.clientName);
  signageApi = new SignageApi(config.apiHost, optionProvider, null, null, config.clientName);
  appApi = new AppApi(config.apiHost, optionProvider, null, null, config.clientName);
  menuApi = new MenuApi(config.apiHost, optionProvider, null, null, config.clientName);
  menuGQLApi = new MenuApi(config.smorderGraphHost, optionProvider, null, null, config.clientName);

  const login = createLoginSaga(allowedRoles, !config.onPremiseMode && [put(navigate({ route: '/' }))]);


  yield all([
    // auth
    takeEvery(loginAction.INIT, login, authApi),

    // orders
    takeEvery(loadOrdersAction, loadOrders, orderApi),
    takeEvery(loadOrderAction, loadOrder, orderApi),
    takeLatest(proceedOrderAction, proceedOrder, orderApi),
    takeEvery(declineOrderAction, declineOrder, orderApi),
    takeEvery(actionOnOrdercardAction, handleOrderCardAction, orderApi),
    takeEvery(setModeAction, setMode, orderApi),
    takeLatest(resetOrderSearchValueAction, scheduleSearchFieldReset, orderApi),
    takeEvery(setDeliveryTimeAction.INIT, setDeliveryTime, orderApi),

    // printer
    takeEvery(startPrintOrderAction, printOrder, orderApi),
    takeEvery(initPrinterAction, initPrinter, orderApi),
    takeEvery(initPrinterFailedAction, initPrinterFailed, orderApi),
    takeEvery(printOrderFailedAction, printFailed, orderApi),
    takeEvery(reconnectPrinterAction, reconnect, orderApi),
    takeEvery(reconnectPrinterFinishedAction, reconnectFinished, orderApi),
    takeEvery(printArticleListAction, printArticleList, orderApi),

    // alert
    takeEvery(closeAlertAction, closeAlert),

    // signage
    takeEvery(loadSignageOrdersAction, loadSignageOrders, signageApi),

    // app
    takeEvery(loadUiOptionsAction, loadUiOptions, appApi),
    takeEvery(toggleFullScreenAction, toggleFullScreen, appApi),

    // scanner
    takeEvery(setPendingScannerInputAction, handleScan, orderApi),

    // location
    takeLatest(loadLocationAction, loadLocation, signageApi),

    // Menu
    takeEvery(loadMenuTreeAction.INIT, loadMenuTree, menuGQLApi),
    takeEvery(updateMenuAction.INIT, updateMenu, menuApi),
    takeEvery(updateCategoryAction.INIT, updateCategory, menuApi),
    takeEvery(updateMenuEntryAction.INIT, updateMenuEntry, menuApi),
    takeEvery(loadProductsAction.INIT, loadProducts, menuApi),
    takeEvery(updateProductAction.INIT, updateProduct, menuApi),
    takeEvery(updateMenusAction.INIT, updateMenus, menuApi),
    takeEvery(updateCategoriesAction.INIT, updateCategories, menuApi),
    takeEvery(updateMenuEntriesAction.INIT, updateMenuEntries, menuApi),
    takeEvery(updateProductsAction.INIT, updateProducts, menuApi),
    takeEvery(loadProductionPlacesAction.INIT, loadProductionPlaces, menuApi),
  ]);
}
